export const PAGES = {
  DASHBOARD: 'dashboard',
  INCOME_CAREER: 'income-career',
  FINANCIAL_HEALTH: 'financial-health',
  LOANS_DEBT: 'loans-debt',
  LIFE_DECISIONS: 'life-decisions',
  INVESTING_RETIREMENT: 'investing-retirement',
  SETTINGS: 'settings',
  PRICING: 'pricing',
}

export function getThemeColors(theme) {
  if (theme === 'light') {
    return {
      primary: '#0891b2',
      secondary: '#2563eb',
      positive: '#0d9488',
      negative: '#e11d48',
      warning: '#d97706',
      chartGrid: 'rgba(8,145,178,0.08)',
      chartTick: '#3d6b84',
      incomeBar: '#0d9488',
      expenseBar: '#e11d48',
      savingsLine: '#0891b2',
      savingsGradientStart: 'rgba(8,145,178,0.3)',
      savingsGradientEnd: 'rgba(8,145,178,0)',
      referenceLine: '#d97706',
    }
  }
  return {
    primary: '#22d3ee',
    secondary: '#3b82f6',
    positive: '#2dd4bf',
    negative: '#fb7185',
    warning: '#fbbf24',
    chartGrid: 'rgba(34,211,238,0.08)',
    chartTick: '#8b9db0',
    incomeBar: '#2dd4bf',
    expenseBar: '#fb7185',
    savingsLine: '#22d3ee',
    savingsGradientStart: 'rgba(34,211,238,0.3)',
    savingsGradientEnd: 'rgba(34,211,238,0)',
    referenceLine: '#fbbf24',
  }
}
